import { render, staticRenderFns } from "./PublishProduct.vue?vue&type=template&id=6f1cdae2&scoped=true"
import script from "./PublishProduct.vue?vue&type=script&lang=js"
export * from "./PublishProduct.vue?vue&type=script&lang=js"
import style0 from "./PublishProduct.vue?vue&type=style&index=0&id=6f1cdae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1cdae2",
  null
  
)

export default component.exports